import axios from 'axios';
import { Placename } from '../models/Placename';
import store from '../store';

let token = '';

const apiClient = axios.create({
    // baseURL: 'https://localhost:44312',
    baseURL: 'https://placenames-webapi.azurewebsites.net',
    withCredentials: false, // This is the default
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

axios.interceptors.response.use(undefined, (err) => {
    return new Promise((resolve, reject) => {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            // attempt token refresh / go back to login screen if there is ever an unauthorized response
            const user = store.getters.user;
            if (user) {
                user.refreshToken();
            }
        } else {
            throw err;
        }
    });
});

export default {
    upsertPlacename(placename: Placename) {
        token = store.getters.token;
        return apiClient.post('/mikmaw', placename, { headers: {Authorization: `Bearer ${token}`} });
    },
    deletePlacename(objectId: number) {
        token = store.getters.token;
        return apiClient.delete('/mikmaw/' + objectId, { headers: {Authorization: `Bearer ${token}`} });
    },
    getFileNames() {
        token = store.getters.token;
        return apiClient.get('/mikmawAudio', { headers: {Authorization: `Bearer ${token}`}});
    },
    uploadAudio(formData: FormData) {
        console.log(formData);
        token = store.getters.token;
        return apiClient.post('/mikmawAudio', formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'audio/mpeg',
                'Authorization': `Bearer ${token}`,
            },
        });
    },
    deleteAudio(filename: string) {
        token = store.getters.token;
        return apiClient.delete('/mikmawAudio/' + filename, { headers: {Authorization: `Bearer ${token}`} });
    },

    // admin:placenames only
    approve(id: number) {
        token = store.getters.token;
        return apiClient.get('/mikmaw/approve/' + id, { headers: {Authorization: `Bearer ${token}`} });
    },
    reject(id: number) {
        token = store.getters.token;
        return apiClient.get('/mikmaw/reject/' + id, { headers: {Authorization: `Bearer ${token}`} });
    },
};
